import React, { Component } from 'react';
import { Carousel, Modal, Row, Col, Button } from 'antd';
import { path } from 'ramda';
import { asyncConnect } from 'react-async-client';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';

import Spinner from 'components/common/Spinner';
import Error from 'components/common/Error';
import Date from 'components/common/cards/Date';
import PersonName from 'components/common/cards/person/PersonName';
import { getPhotoReport, getPhotoReportSettings, fullAutoOptions } from 'actions/asyncActions';
import { openPreviewModal } from 'actions/modalActions';
import { getPhotoReportTypeName, getPhotoReportTypeSettings } from 'constants/photoReports';
import { getFileUrl } from 'utils/file';

@asyncConnect({
    getPhotoReport: getPhotoReport
        .withPayload(path(['params', 'id']))
        .withOptions(fullAutoOptions),
}, state => ({
    photoReportSettings: getPhotoReportSettings.selectData(state),
}), { openPreviewModal })
export default class PhotoReportModal extends Component {
    render() {
        const { modal, params, getPhotoReport: { data, meta }, openPreviewModal, photoReportSettings } = this.props;
        const typeLabels = getPhotoReportTypeSettings(photoReportSettings, data.type || params.type);

        return (
            <Modal {...modal} title={<span><Date date={params.date} /> {`${params._embedded.network.name} ${params._embedded.shop.name} ${getPhotoReportTypeName(photoReportSettings, params.type)} `} <PersonName person={params._embedded.promoter} /></span>} footer={null} className='preview-modal'>
                <div>
                    {meta.pending ? (
                        <Spinner />
                    ) : meta.error ? (
                        <Error meta={meta} />
                    ) : (
                        <div>
                            <Row>
                                <Col sm={12} style={{ textAlign: 'center' }}><b>{typeLabels.photosLabel}</b></Col>
                                <Col sm={12} style={{ textAlign: 'center' }}><b>{typeLabels.additionalPhotosLabel}</b></Col>
                            </Row>
                            <Row gutter={16}>
                                { data.photos && data.photos.length ? (
                                    <Col sm={12}>
                                        <div className='customCarousel' style={{height: 'calc(100% - 48px)', maxHeight: 500}}>
                                            <Carousel ref={node => this.photosSlider = node}>
                                                {(data.photos || []).map(id => (
                                                    <div>
                                                        <img
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                openPreviewModal(getFileUrl(id));
                                                            }}
                                                            src={getFileUrl(id)}
                                                            alt=''
                                                        />
                                                    </div>
                                                ))}
                                            </Carousel>
                                        </div>
                                        <div style={{ textAlign: 'center', padding: 8 }}>
                                            <Button.Group>
                                                <Button onClick={() => this.photosSlider.prev()}><ArrowLeftOutlined /></Button>
                                                <Button onClick={() => this.photosSlider.next()}><ArrowRightOutlined /></Button>
                                            </Button.Group>
                                        </div>
                                    </Col>
                                ) : <Col sm={12} style={{ textAlign: 'center' }}>Нет фото</Col>}
                                { data.additionalPhotos && data.additionalPhotos.length ? (
                                    <Col sm={12}>
                                        <div className='customCarousel' style={{height: 'calc(100% - 48px)', maxHeight: 500}}>
                                            <Carousel ref={node => this.photosAdditionalSlider = node}>
                                                {(data.additionalPhotos || []).map(id => (
                                                    <div>
                                                        <img
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                openPreviewModal(getFileUrl(id));
                                                            }}
                                                            src={getFileUrl(id)}
                                                            alt=''
                                                        />
                                                    </div>
                                                ))}
                                            </Carousel>
                                        </div>
                                        <div style={{ textAlign: 'center', padding: 8 }}>
                                            <Button.Group>
                                                <Button onClick={() => this.photosAdditionalSlider.prev()}><ArrowLeftOutlined /></Button>
                                                <Button onClick={() => this.photosAdditionalSlider.next()}><ArrowRightOutlined /></Button>
                                            </Button.Group>
                                        </div>
                                    </Col>
                                ) : <Col sm={12} style={{ textAlign: 'center' }}>Нет фото</Col>}
                            </Row>
                            <Row>
                                <Col sm={12} style={{ textAlign: 'center' }}><b>{typeLabels.commentLabel}</b></Col>
                                <Col sm={12} style={{ textAlign: 'center' }}><b>{typeLabels.additionalCommentLabel}</b></Col>
                            </Row>
                            <Row>
                                <Col sm={12}>{data.comment}</Col>
                                <Col sm={12}>{data.additionalComment}</Col>
                            </Row>
                        </div>
                    )}
                </div>
            </Modal>
        );
    }
};

